module.exports = __webpack_public_path__ + "images/emoji/mortar_board.409a122fe605f38a63a8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mortar_board.png
// module id = RXNX
// module chunks = 13